import styled from 'styled-components'

export const BuyButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 35px;
  background: #8f4bd0;
  border-radius: 17.5px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 900;
  font-size: 10px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  text-decoration: none;
  transition: background-color 0.2s;
  margin-top: 10px;

  &:hover {
    background: #7f3bc0;
  }

  &:focus {
    outline: none;
    ring: 2px;
    ring-offset: 2px;
    ring-color: #8f4bd0;
  }
`

export const OnrampWrapper = styled.div`
  background: #18191d;
  border: 1px solid rgba(240, 243, 246, 0.1);
  border-radius: 7px;
  padding: 15px;

  max-height: 80vh;

  @screen sm {
    padding: 26px 29px;
  }
`

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 1rem;
  margin-bottom: 0.5rem;
`

export const HeaderSpan = styled.span`
  font-size: 14px;
`

export const BalanceRow = styled.div`
  display: flex;
  align-items: center;
`

export const Network = styled.div`
  display: flex;
  align-items: center;
  margin: 15px;
`

export const WithdrawAmount = styled.input`
  width: 100%;
  background: #212226;
  border-radius: 20px;
  border: 1px solid #2f2f33;
  height: 40px;
  display: flex;
  justify-content: center;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
`

export const CenteredText = styled.div`
  font-family: 'Inter';
  font-weight: 900;
  text-align: center;
  color: #ffffff;
  margin: 20px 0;
`
